import {_} from 'lodash';
import * as ko from "knockout";
import {IMessageData, IObjectData, ISyncField} from "../../../../../index";
import {KOSubscriptionTracker} from "../../../../../util/KOSubscriptionTracker";
import {ObjectTypeId} from "../../../../../constants";
import {getObjectDefinition, getSourceTranslation} from "../../../../../util/misc";
import {IRuleMutableAttribute} from "../../../index";
import {IDialogOptions} from "../../../../dialog/index";
import {nsRule} from "../nsRule";
import DialogPickObjectAttributeTitle = nsRule.DialogPickObjectAttributeTitle;
import pick_object_attributeHtml from './pick-object-attribute.html?raw';

export let template = pick_object_attributeHtml;

interface IParams {
    callback: (value: any) => void
    dialog: IDialogOptions
    ruleMutable: IRuleMutableAttribute
}

enum Step {
    PickObjectType,
    PickObject,
    PickAttribute,
}

export class viewModel {
    private ObjectTypeId = ObjectTypeId;
    private objectTypes = [
        ObjectTypeId.User,
        ObjectTypeId.Department,
        ObjectTypeId.Group,
    ].map(id => ({
        id: id,
        def: getObjectDefinition(id),
    }));
    private messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();

    private Step = Step;
    private step: KnockoutObservable<Step | null> = ko.observable(null);
    private cb: (value: any) => void;
    private dialog: IDialogOptions;

    private objectTypeId: KnockoutObservable<ObjectTypeId | null> = ko.observable(null);
    private objectData: KnockoutObservable<IObjectData | null> = ko.observable(null);
    private syncfield: KnockoutObservable<ISyncField | null> = ko.observable(null);
    private ruleMutable: IRuleMutableAttribute;
    private prioritySyncfield: ISyncField | null = null;

    constructor(params: IParams) {
        this.cb = params.callback;
        this.dialog = params.dialog;
        this.ruleMutable = params.ruleMutable;

        this.kosub.subscribe(this.step, () => {
            const suffix: string = ((): string => {
                switch (this.step()) {
                    case Step.PickObjectType:
                        return 'objekttype';
                    case Step.PickObject:
                        return getObjectDefinition(this.objectTypeId()!)?.translation ?? '';
                    case Step.PickAttribute:
                        return 'verdi';
                    default:
                        return '';
                }
            })();
            (this.dialog.title as KnockoutObservable<string>)(`${DialogPickObjectAttributeTitle} [${suffix}]`);
        });

        this.kosub.subscribe(this.objectTypeId, () => this.step(Step.PickObject));
        this.kosub.subscribe(this.objectData, () => this.step(Step.PickAttribute));
        this.kosub.subscribe(this.syncfield, () => {
            const sf = this.syncfield();
            if (!sf) {
                return;
            }
            this.cb(sf.value);
            this.dialog.doClose?.();
        });

        this.step(Step.PickObjectType);
    }

    private syncfields = ko.pureComputed((): ISyncField[] => {
        const objectData = this.objectData();
        if (!objectData) {
            return [];
        }
        this.prioritySyncfield = null;
        const ret = _.sortBy(objectData.syncfields.filter((sf: ISyncField) => sf.value), (sf: ISyncField) => getSourceTranslation(sf).toLowerCase());
        const index = ret.findIndex((val: ISyncField) => val.name == this.ruleMutable.attribute());
        if (index != -1) {
            this.prioritySyncfield = ret.splice(index, 1)?.[0] ?? null;
            if (this.prioritySyncfield) {
                ret.unshift(this.prioritySyncfield);
            }
        }
        return ret;
    });

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
